

export default {
  props: {
    heading: {
      type: String,
      default: ''
    },
    reveal: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  setup (props, { emit }) {
    const closeFlipper = () => {
      emit('close')
    }

    const clickOutside = () => props.reveal ? closeFlipper() : null

    return {
      closeFlipper,
      clickOutside
    }
  }
}
